DeliveryInformationController.$inject = ['$transitions', 'CorporateService', '$rootScope']

export default function DeliveryInformationController($transitions, CorporateService, $rootScope) {
  var vm = this

  $transitions.onBefore({}, () => {
    
  }, {invokeLimit: 1})
}